module.exports = __webpack_public_path__ + "static/renovate-5b13ef87d01ac23d57211ee8868a3587.jpg";